module.exports = __webpack_public_path__ + "img/blue_nylon.adaaf09b.png";